export default "__VITE_ASSET__DaC9lW$w__"